import { Text } from 'uikit';

export const ChooseSectionText = ({ text, className }: { text: string; className?: string }) => (
    <Text
        className={className}
        view="secondary"
        align="center"
        style={{
            borderTop: '1px solid rgba(0, 65, 102, 0.2)',
            borderBottom: '1px solid rgba(0, 65, 102, 0.2)',
            padding: '8px 0',
        }}
    >
        {text}
    </Text>
);

ChooseSectionText.displayName = 'ChooseSectionText';
